/**
 * component-card-bundle-includes-vwo.js
 * Test A/B (VWO) — Toggle del overlay "SE INCLUYE" en móvil (lupa -> abre / cerrar -> cierra)
 * Namespace: BundleIncludesVwo
 * No usa querySelectorAll global agresivo en document, todo escopeado a [data-card-bundle-includes-vwo]
 * No depende de ni modifica ningún otro script del theme.
 */
(function () {
  function syncPanelSizeBundleIncludesVwo(container) {
    var cardWrapper = container.dataset.cardWrapperRefBundleIncludesVwo
      ? document.getElementById(container.dataset.cardWrapperRefBundleIncludesVwo)
      : container.closest('.card-wrapper');
    if (!cardWrapper) return;
    var rect = cardWrapper.getBoundingClientRect();
    container.style.top = rect.top + 'px';
    container.style.left = rect.left + 'px';
    container.style.width = rect.width + 'px';
    container.style.height = rect.height + 'px';
  }

  // Saca el contenedor del flujo normal del DOM (donde puede haber overflow:hidden
  // o transform en ancestros, p.ej. .card--card.gradient { transform: perspective(0) },
  // que rompen el comportamiento esperado de position:fixed) y lo mueve directamente
  // bajo <body>. Al cerrar, lo devuelve a su sitio original para no tocar la
  // estructura del tema de forma permanente.
  function openBundleIncludesVwoPanel(container) {
    var cardWrapper = container.closest('.card-wrapper');
    if (!cardWrapper) return;

    if (!container.dataset.originalParentMarkedBundleIncludesVwo) {
      var placeholder = document.createComment('bundle-includes-vwo-placeholder');
      container.parentNode.insertBefore(placeholder, container);
      container._placeholderBundleIncludesVwo = placeholder;
      container.dataset.originalParentMarkedBundleIncludesVwo = 'true';
    }

    if (!cardWrapper.id) {
      cardWrapper.id = 'cardWrapperBundleIncludesVwo-' + Math.random().toString(36).slice(2, 10);
    }
    container.dataset.cardWrapperRefBundleIncludesVwo = cardWrapper.id;

    document.body.appendChild(container);
    syncPanelSizeBundleIncludesVwo(container);
    container.classList.add('is-openBundleIncludesVwo');
    scrollYAtOpenBundleIncludesVwo = window.scrollY;
  }

  function closeBundleIncludesVwoPanel(container) {
    container.classList.remove('is-openBundleIncludesVwo');
    if (container._placeholderBundleIncludesVwo && container._placeholderBundleIncludesVwo.parentNode) {
      container._placeholderBundleIncludesVwo.parentNode.insertBefore(container, container._placeholderBundleIncludesVwo);
    }
    // Limpia los estilos en línea (top/left/width/height) que syncPanelSizeBundleIncludesVwo
    // puso mientras el contenedor estaba en position:fixed dentro de <body>. Si no se quitan,
    // al volver dentro de .card__media (position:absolute por CSS) esos valores absolutos en
    // px descolocan todo el contenido, incluida la lupa, dejándola fuera de la vista.
    container.style.top = '';
    container.style.left = '';
    container.style.width = '';
    container.style.height = '';
  }

  function initBundleIncludesVwo(root) {
    var containers = root.querySelectorAll('[data-card-bundle-includes-vwo]');

    containers.forEach(function (container) {
      if (container.dataset.boundBundleIncludesVwo === 'true') return; // evita doble binding
      container.dataset.boundBundleIncludesVwo = 'true';

      var trigger = container.querySelector('[data-card-bundle-includes-vwo-trigger]');
      var closeBtn = container.querySelector('[data-card-bundle-includes-vwo-close]');
      var addToCartBtn = container.querySelector('[data-card-bundle-includes-vwo-add-to-cart]');

      if (trigger) {
        var openPanelBundleIncludesVwo = function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          openBundleIncludesVwoPanel(container);
        };
        trigger.addEventListener('pointerdown', openPanelBundleIncludesVwo, true);
        trigger.addEventListener('touchstart', openPanelBundleIncludesVwo, true);
        trigger.addEventListener('mousedown', openPanelBundleIncludesVwo, true);
        trigger.addEventListener('click', openPanelBundleIncludesVwo, true);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeBundleIncludesVwoPanel(container);
        });
      }

      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (addToCartBtn.disabled) return;

          var variantId = addToCartBtn.getAttribute('data-variant-id');
          if (!variantId) return;

          var labelEl = addToCartBtn.querySelector('[data-card-bundle-includes-vwo-add-to-cart-label]');
          var originalLabel = labelEl ? labelEl.textContent : '';
          addToCartBtn.disabled = true;
          if (labelEl) labelEl.textContent = '...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('add to cart failed');
              return response.json();
            })
            .then(function () {
              window.location.href = '/cart';
            })
            .catch(function () {
              addToCartBtn.disabled = false;
              if (labelEl) labelEl.textContent = originalLabel;
            });
        });
      }

      /**
       * Cualquier click dentro del panel que NO sea sobre el botón de cerrar
       * ni sobre el botón de agregar al carrito debe navegar a la PDP del
       * producto principal de la card.
       */
      var panel = container.querySelector('[data-card-bundle-includes-vwo-panel]');
      if (panel) {
        panel.addEventListener('click', function (event) {
          var isCloseClick = event.target.closest('[data-card-bundle-includes-vwo-close]');
          var isAddToCartClick = event.target.closest('[data-card-bundle-includes-vwo-add-to-cart]');
          if (isCloseClick || isAddToCartClick) return;

          var productUrl = container.getAttribute('data-product-url');
          if (!productUrl) return;

          window.location.href = productUrl;
        });
      }
    });
  }

  function bootBundleIncludesVwo() {
    initBundleIncludesVwo(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBundleIncludesVwo);
  } else {
    bootBundleIncludesVwo();
  }

  /**
   * Cerramos el panel automáticamente en el PRIMER evento de scroll real de
   * la PÁGINA detectado mientras esté abierto (sin esperar a que el scroll
   * supere ningún umbral de píxeles). El panel usa position:fixed con
   * coordenadas calculadas en el momento de abrir, que no se actualizan
   * mientras el usuario hace scroll; si se esperara a que el desplazamiento
   * acumulado superase un umbral antes de cerrar, durante esos primeros
   * píxeles de scroll el panel se queda "clavado" en su sitio mientras el
   * fondo de la página ya se mueve por debajo, generando un efecto visual
   * de desfase/salto justo antes de desaparecer. Cerrando en el primer
   * evento, ese desfase es imperceptible.
   *
   * IMPORTANTE: el listener se registra en fase de captura (true) para
   * detectar scroll en cualquier parte, pero por eso mismo también recibe
   * eventos de scroll de contenedores internos no relacionados con la página
   * — por ejemplo, un carrusel autorotativo del propio tema (global.js,
   * autoRotateSlides/setSlidePosition) que desplaza su contenido cada pocos
   * segundos sin intervención del usuario. Ese scroll interno NO debe cerrar
   * nuestro panel. Por eso filtramos explícitamente: solo actuamos cuando
   * event.target es window/document/documentElement/body — es decir, scroll
   * real de la página — e ignoramos cualquier evento cuyo origen sea otro
   * elemento (como el carrusel).
   */
  function closeAllOpenPanelsOnScrollBundleIncludesVwo(event) {
    var isPageScroll = event.target === document || event.target === window || event.target === document.documentElement || event.target === document.body;
    if (!isPageScroll) return;

    var openContainers = document.querySelectorAll('.cardBundleIncludesVwo.is-openBundleIncludesVwo');
    if (openContainers.length === 0) return;

    openContainers.forEach(function (container) {
      closeBundleIncludesVwoPanel(container);
    });
  }
  window.addEventListener('scroll', closeAllOpenPanelsOnScrollBundleIncludesVwo, true);

  /**
   * FIX Safari iOS: en iOS, durante un gesto de scroll táctil, el contenido
   * se desplaza visualmente de forma nativa e inmediata, pero el evento
   * 'scroll' de JavaScript se dispara con un retraso perceptible respecto a
   * ese movimiento (comportamiento propio de iOS Safari, no un bug nuestro).
   * Como nuestro panel usa position:fixed con coordenadas congeladas en el
   * momento de abrir, ese retraso provoca que se vea "clavado" en pantalla
   * mientras el fondo ya se desliza por debajo. 'touchmove' se dispara mucho
   * más pronto (es el evento nativo del propio gesto), así que lo usamos
   * como disparador adicional para cerrar el panel lo antes posible.
   * Se excluyen los touchmove que ocurran DENTRO del propio panel abierto,
   * para no cerrarlo si el usuario solo está haciendo scroll dentro de la
   * lista de productos incluidos (que tiene overflow-y:auto).
   */
  function closeAllOpenPanelsOnTouchMoveBundleIncludesVwo(event) {
    var openContainers = document.querySelectorAll('.cardBundleIncludesVwo.is-openBundleIncludesVwo');
    if (openContainers.length === 0) return;

    var isInsideOpenPanel = event.target.closest('.cardBundleIncludesVwo.is-openBundleIncludesVwo');
    if (isInsideOpenPanel) return;

    openContainers.forEach(function (container) {
      closeBundleIncludesVwoPanel(container);
    });
  }
  document.addEventListener('touchmove', closeAllOpenPanelsOnTouchMoveBundleIncludesVwo, { capture: true, passive: true });

  /**
   * FIX click-through: en esta card, el link ::after que cubre TODA la card
   * (.card__heading a::after) gana el hit-test incluso sobre nuestro botón
   * con z-index mayor, porque vive en otro stacking context. En vez de
   * recortar geométricamente ese ::after (frágil, depende del alto variable
   * de la card), interceptamos el click sobre el <a> en la fase de CAPTURA,
   * a nivel de documento — es decir, antes de que el navegador siga el href.
   * Si el punto de click cae dentro de nuestro botón lupa (visualmente),
   * cancelamos la navegación y abrimos el panel en su lugar.
   */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.card__heading a, .full-unstyled-link');
    if (!link) return;

    var cardWrapper = link.closest('.card-wrapper');
    if (!cardWrapper) return;

    var trigger = cardWrapper.querySelector('[data-card-bundle-includes-vwo-trigger]');
    if (!trigger) return;

    var rect = trigger.getBoundingClientRect();
    var x = event.clientX;
    var y = event.clientY;
    var withinTrigger = x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;

    if (withinTrigger) {
      event.preventDefault();
      event.stopPropagation();
      var container = cardWrapper.querySelector('[data-card-bundle-includes-vwo]');
      if (container) openBundleIncludesVwoPanel(container);
    }
  }, true); // capturing: se ejecuta antes de que el navegador procese el href del link

  // Por si la grid de productos se re-renderiza vía AJAX (filtros, paginación infinita, etc.)
  // Exponemos un init manual con nombre único, sin tocar eventos globales del theme.
  window.initBundleIncludesVwo = initBundleIncludesVwo;
})();